<template>
  <v-application v-if="access.setting_receipt">
    <!-- <template>
      <div>
        <v-alert
          v-model="alert"
          position="top-right"
          dismissible
          shaped
          type="success"
          timeout="1500"
        >
        </v-alert>
      </div>
    </template> -->
    <v-settings>
      <v-toolbar flat class="mx-5">
        <v-toolbar-title>{{ $t("receipt_settings") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="store"
          :label="$t('stores')"
          hide-details
          v-bind:items="stores"
          item-value="_id"
          item-text="name"
        />
      </v-toolbar>
      <v-card-text class="mx-5">
        <p>{{ $t("logo") }}</p>
        <v-layout row my-5>
          <v-flex px-2 md4>
            <p>{{ $t("emailed_receipt") }}</p>
            <v-hover #default="{ hover }">
              <v-card
                width="150"
                height="130"
                outlined
                class="text-center"
                :loading="email_receipt_loading"
                :class="
                  receipt.emailed_receipt != ''
                    ? 'pa-0'
                    : hover
                    ? 'py-10'
                    : 'pa-10'
                "
              >
                <v-btn
                  v-if="hover && receipt.emailed_receipt != ''"
                  icon
                  @click="receipt.emailed_receipt = ''"
                  :style="
                    receipt.emailed_receipt == ''
                      ? 'position: absolute; margin-top: -50px; margin-left: -65px;'
                      : 'position: absolute; margin-top: -10px; margin-left: -85px; z-index: 5'
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-icon v-if="receipt.emailed_receipt == ''" x-large
                  >mdi-image-size-select-actual</v-icon
                >
                <v-img
                  height="125"
                  v-else
                  class="ma-0"
                  :src="receipt.emailed_receipt"
                ></v-img>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      v-card--reveal
                      pointer
                    "
                  >
                    <v-card
                      block
                      color="primary"
                      dark
                      tile
                      class="
                        d-flex
                        transition-fast-in-fast-out
                        v-card--reveal
                        pointer
                      "
                    >
                      <label
                        class="file-select pointer py-1"
                        style="width: 100%"
                      >
                        {{ $t("upload") }}
                        <input
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="uploadEmailReceipt"
                        />
                      </label>
                    </v-card>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex px-2 md4>
            <p>{{ $t("printed_receipt") }}</p>
            <v-hover #default="{ hover }">
              <v-card
                width="150"
                height="130"
                outlined
                class="text-center"
                :loading="printed_receipt_loading"
                :class="
                  receipt.printed_receipt != ''
                    ? 'pa-0'
                    : hover
                    ? 'py-10'
                    : 'pa-10'
                "
              >
                <v-btn
                  v-if="hover && receipt.printed_receipt != ''"
                  icon
                  @click="receipt.printed_receipt = ''"
                  :style="
                    receipt.printed_receipt == ''
                      ? 'position: absolute; margin-top: -50px; margin-left: -65px;'
                      : 'position: absolute; margin-top: -10px; margin-left: -85px; z-index: 5'
                  "
                  ><v-icon>mdi-close</v-icon>
                </v-btn>
                <v-icon v-if="receipt.printed_receipt == ''" x-large
                  >mdi-image-size-select-actual</v-icon
                >
                <v-img
                  height="125"
                  v-else
                  class="ma-0"
                  :src="receipt.printed_receipt"
                ></v-img>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      v-card--reveal
                      pointer
                    "
                  >
                    <v-card
                      block
                      color="primary"
                      dark
                      tile
                      class="
                        d-flex
                        transition-fast-in-fast-out
                        v-card--reveal
                        pointer
                      "
                    >
                      <label
                        class="file-select pointer py-1"
                        style="width: 100%"
                        for="file-select"
                        @click.prevent="uploadPrintReceipt"
                      >
                        {{ $t("upload") }}
                      </label>
                      <input
                          id="file-select"
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="uploadPrintedReceipt"
                          
                        />
                    </v-card>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md11>
            <v-text-field
              v-model="receipt.header"
              :label="$t('header')"
              counter="500"
            ></v-text-field>
          </v-flex>
          <v-flex md11>
            <v-text-field
              v-model="receipt.footer"
              :label="$t('footer')"
              counter="500"
            ></v-text-field>
          </v-flex>
          <v-flex md11>
            <v-list-item class="ma-0 pa-0">
              <v-list-item-content
                class="noselect"
                @click="
                  receipt.show_customer_info = !receipt.show_customer_info
                "
              >
                <v-list-item-title>{{
                  $t("show_customer_info")
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="receipt.show_customer_info" />
              </v-list-item-action>
            </v-list-item>
          </v-flex>
          <v-flex md11>
            <v-list-item class="ma-0 pa-0">
              <v-list-item-content
                class="noselect"
                @click="receipt.show_comments = !receipt.show_comments"
              >
                <v-list-item-title>{{ $t("show_comments") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="receipt.show_comments" />
              </v-list-item-action>
            </v-list-item>
          </v-flex>
        </v-layout>
      </v-card-text>
      <template #actions>
        <v-layout class="mx-3">
          <v-spacer></v-spacer>
          <v-btn text @click="getReceipt">{{ $t("cancel") }}</v-btn>
          <v-btn
            text
            @click="updateReceipt"
            :loading="update_loading"
            color="primary"
            >{{ $t("save") }}</v-btn
          >
        </v-layout>
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Receipt from "../../mixins/settings/receipts";
import Services from "../../mixins/services";

export default {
  name: "SettingReceipt",
  mixins: [Receipt, Services],
  data: () => ({
    email_receipt_loading: false,
    email_receipt_error: false,
    email_receipt_error_message: "",
    printed_receipt_loading: false,
    printed_receipt_error: false,
    printed_receipt_error_message: "",
    update_loading: false,
    alert: false,
  }),
  watch: {
    stores: {
      deep: true,
      handler() {
        if (this.stores && this.stores.length > 0) {
          this.store = this.stores[0]._id;
        }
      },
    },
    store() {
      this.getReceipt();
    },
  },
  methods: {
    uploadPrintReceipt() {
      document.getElementById("file-select").click();
    },

    async uploadEmailReceipt(e) {
      this.email_receipt_loading = true;
      await this.UploadImage(e);
      this.email_receipt_loading = false;
      this.email_receipt_error = this.loadImageError;
      this.email_receipt_error_message = this.loadImageErrorMessage;
      this.receipt.emailed_receipt = this.loadedImagePath;
    },
    async uploadPrintedReceipt(e) {
      this.printed_receipt_loading = true;
      await this.UploadImage(e);
      this.printed_receipt_loading = false;
      this.printed_receipt_error = this.loadImageError;
      this.printed_receipt_error_message = this.loadImageErrorMessage;
      this.receipt.printed_receipt = this.loadedImagePath;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}
.file-select > input[type="file"] {
  display: none;
}
.pointer {
  cursor: pointer;
}

.noselect {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>

